import React, { useContext, useEffect, useRef, useState } from "react";
import ContentLayout from "../../layout/ContentLayout";
import useSWR, { useSWRConfig } from "swr";
import axios from "axios";
import Pagination from "../../utils/pagination";

import { formatDate } from "../../utils/Common";
import Swal from "sweetalert2";
import { get } from "../../services/apiService";
import { AppContext } from "../../context/context";
import { ChevronDown, ChevronUp } from "lucide-react";
import DatePicker from "react-datepicker";
import DeliveryModal from "./DeliveryModal";

// Icons
const SearchIcon = () => (
  <svg
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

const FilterIcon = () => (
  <svg
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
  </svg>
);

const MoreIcon = () => (
  <svg
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
    />
  </svg>
);

const Orders = () => {

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const [deliveryAccountList, setDeliveryAccountList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [orderIndex, setOrderIndex] = useState("");

  const getDelivery = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}delivery-method-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setDeliveryList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        // console.log(error);
      });
  };

  const getDeliveryAccountList = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}delivery-info-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setDeliveryAccountList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        // console.log(error);
      });
  };

  useEffect(() => {
    getDelivery();
    getDeliveryAccountList();
  }, []);

  const [activeTab, setActiveTab] = useState("Order Received");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { updateHoldInvoiceList } = useContext(AppContext);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [type, setType] = useState(1);
  const debounceTimeout = useRef(null);
  const { mutate } = useSWRConfig();
  const [currentPage, setCurrentPage] = useState(1);
  const statusRef = useRef(null);
  const perPage = 20;
  const [expandedRows, setExpandedRows] = useState({});

  const [orderActionsOpen, setOrderActionsOpen] = useState(null);
  const [orderStatusOpen, setOrderStatusOpen] = useState(null);
  const actionsRef = useRef(null);

  //delivery modal variables
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);

  const toggleRow = (invoiceId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [invoiceId]: !prev[invoiceId],
    }));
  };

  useEffect(() => {
    const payload = {
      limit: perPage,
      page: currentPage,
      type: type,
    };
    setRefetch(false);
    const fetchData = () => {
      axios
        .post(`${process.env.REACT_APP_API_URL}order-list`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("order-list.....", res.data.data);
          setInvoices(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchData();
  }, [type, refetch, currentPage]);

  useEffect(() => {
    const handleStatusOutsideClick = (e) => {
      if (statusRef.current && !statusRef.current.contains(e.target)) {
        setDropdownOpen(null);
      }
    };
    document.addEventListener("mousedown", handleStatusOutsideClick);

    return () =>
      document.removeEventListener("mousedown", handleStatusOutsideClick);
  }, [dropdownOpen]);

  const shouldRenderPagination = invoices?.total > perPage;

  const tabs = [
    { type: 1, name: "Order Received", count: "" },
    { type: 2, name: "Order Completed", count: "" },
    { type: 3, name: "Delivery Processing", count: "" },
    { type: 4, name: "Delivered", count: "" },
    { type: 5, name: "Canceled", count: "" },
    { type: 6, name: "Hold", count: "" },
  ];

  const handleOrderStatus = (item, status) => {
    const modifiedOrder = { ...item };
    modifiedOrder.tran_status = status;
    const payload = {
      invoice_id: modifiedOrder.invoice_id,
      status: modifiedOrder.tran_status.toString(),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}update-ecommerce-status`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setRefetch(true);
        if (res.data.success) {
          Swal.fire({
            title: "Invoice Status Updated Successfully",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setDropdownOpen(null);
  };

  const [searchKeyword, setSearchKeyword] = useState("");

  // Call this in your input onChange
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    debounceSearch(value);
  };

  const debounceSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      fetchSearchResults(value);
    }, 700);
  };

  const fetchSearchResults = async (keyword = "") => {
    try {
      if (keyword || startDate || endDate) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}search-ecommerce-invoice`,
          {
            keyword: keyword,
            start_date: startDate ?? "",
            end_date: endDate ?? "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSearchedData(response.data.data.data);
        mutate(
          `${process.env.REACT_APP_API_URL}search-ecommerce-invoice`,
          response.data.data.data,
          false
        );
      } else {
        setSearchedData([]);
        setRefetch(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // When date filters change, auto search with current keyword
  useEffect(() => {
    fetchSearchResults(searchKeyword);
  }, [startDate, endDate]);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const showModalBeforeDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(id, index);
      }
    });
  };

  const deleteData = (id, index) => {
    get(`delete-sale/${id}`, token)
      .then((response) => {
        setRefetch(true);
        if (response.success) {
          console.log("invoice deleted");
          let invoiceList = [...invoices];
          invoiceList.splice(index, 1);
          updateHoldInvoiceList(invoiceList);
        } else {
          console.log("booking delete failed");
        }
      })
      .catch((error) => {
        // loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
        console.log(error);
      });
  };

  const datePickerRef1 = useRef(null);
  const datePickerRef2 = useRef(null);
  const handleDivClick1 = () => {
    if (datePickerRef1.current) {
      datePickerRef1.current.setOpen(true); // Programmatically open the date picker
    }
  };
  const handleDivClick2 = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true); // Programmatically open the date picker
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  return (
    <ContentLayout>
      <div className="bg-white rounded-3xl mt-3 font-nunito p-4 md:p-[26px] space-y-8">
        {loading && (
          <div className="custom-loader-logo">
            {/* <BeatLoader color={"#123abc"} size={20} /> */}
            <img
              className=""
              src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
              alt="logo"
            />
          </div>
        )}
        {/* Tabs */}
        <div className="flex flex-nowrap max-w-[100vw] overflow-x-auto no-scrollbar border-b mb-3 -mx-4 sm:mx-0 px-">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => {
                setActiveTab(tab.name);
                setType(tab.type);
              }}
              className={`px-4 py-2 flex items-center space-x-2 border-b-2 whitespace-nowrap shrink-0 text-sm sm:text-base ${
                activeTab === tab.name
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              <span>{tab.name}</span>
              <span className="text-[10px] sm:text-xs bg-gray-100 rounded-full px-2 py-0.5">
                {tab.count}
              </span>
            </button>
          ))}
        </div>

        {/* Search and Filter */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center sm:justify-between gap-3 sm:gap-4 mb-3">
          <div className="relative w-full sm:flex-1 sm:max-w-sm min-w-0">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <SearchIcon />
            </div>
            <input
              type="text"
              placeholder="Search order..."
              onChange={handleInputChange}
              className="w-full text-[16px] pl-9 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div className="w-full sm:w-auto flex flex-col md:flex-row items-stretch sm:items-center mt-[12px] md:mt-0 font-nunito gap-3 sm:gap-4">
            <div
              className="relative border-[#C1CFEF] py-2.5 border w-full sm:w-auto flex-1 sm:flex-none min-w-[160px] sm:min-w-[190px] rounded-xl z-50"
              onClick={handleDivClick1}
            >
              <DatePicker
                ref={datePickerRef1}
                selected={startDate}
                onChange={handleStartDateChange}
                dateFormat="dd/MM/yyyy"
                className="w-full px-2 focus:outline-none z-20 cursor-pointer"
              />
              <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                Start Date
              </span>
            </div>
            <div
              className="relative border-[#C1CFEF] py-2.5  border w-full sm:w-auto flex-1 sm:flex-none min-w-[160px] sm:min-w-[190px] rounded-xl z-50 "
              onClick={handleDivClick2}
            >
              <DatePicker
                ref={datePickerRef2}
                selected={endDate}
                onChange={handleEndDateChange}
                dateFormat="dd/MM/yyyy"
                className="w-full px-2 focus:outline-none z-20 cursor-pointer"
              />
              <span className="bg-white absolute left-2 px-1 font-semibold text-xs top-0 text-[#102048] translate-y-[-50%]">
                End Date
              </span>
            </div>
            <button
              onClick={() => {
                setStartDate(null);
                setEndDate(null);
              }}
              className="text-sm font-semibold text-white bg-red-500 hover:bg-red-600 transition px-4 py-2 rounded-xl w-full sm:w-auto"
            >
              Clear
            </button>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50 w-full sm:w-auto">
            <FilterIcon />
            <span>Filter</span>
          </button>
        </div>

        {/* {
    <div className="w-full relative px-[27px] overflow-x-auto sm:rounded-lg">
    {" "}
    <div className="custom-loader"></div>{" "}
  </div>
  } */}

        {/* Orders Table */}
        <div className="table-conatiner relative -mx-4 sm:mx-0 overflow-x-auto max-w-[100vw] min-h-96">
          {/* <div className='grid grid-cols-4 sm:grid-cols-5'> */}
          <div className={`grid ${activeTab !== 'Order Received' ? 'grid-cols-6 sm:grid-cols-7' : 'grid-cols-5 sm:grid-cols-6' } min-w-[900px] sm:min-w-0 px-4 sm:px-0 bg-gray-200`}>
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px]">
              Name
            </div>
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center">
              Total Amount
            </div>
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center">
              Delivery Method
            </div>
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center hidden sm:block">
              Date/Time
            </div>
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center">
              Total Items
            </div>

            {(activeTab !== 'Order Received' && <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center">
              Consignment ID
            </div>)}
            <div className="text-xs sm:text-[14px] font-nunito font-bold text-[#000232] py-2 sm:py-[8px] text-center">
              Action
            </div>
          </div>

          <div className="mb-2 border-t-[1px] border-solid border-[#E7EBF4]">
            {searchKeyword || startDate || endDate ? (
              searchedData.map((order, index) => {
                const isExpanded = expandedRows[order.invoice_id] || false;
                return (
                  <div
                    key={index}
                    className={`py-3 sm:py-[13px] font-nunito grid ${activeTab !== 'Order Received' ? 'grid-cols-6 sm:grid-cols-7' : 'grid-cols-5 sm:grid-cols-6' } items-center gap-3 min-w-[900px] sm:min-w-0 px-4 sm:px-0`}
                  >
                    {console.log("Order......... ", order)}
                    <div className="text-sm sm:text-[14px] space-y-1 sm:space-y-0 min-w-0">
                      <h1 className="text-[#000232] font-[500] truncate max-w-[160px] sm:max-w-none">
                        {order?.invoice_id}
                      </h1>
                      <p className="text-[#87889E] font-[700]">
                        {order?.delivery_customer_name}
                      </p>
                      <button
                        onClick={() => toggleRow(order.invoice_id)}
                        className="text-[#000000] inline-flex items-center p-1 -ml-1"
                      >
                        {isExpanded ? (
                          <ChevronUp size={20} />
                        ) : (
                          <ChevronDown size={20} />
                        )}
                      </button>

                      {isExpanded && (
                        <>
                          <p className="text-[#87889E] font-[700]">
                            {order?.delivery_customer_phone}
                          </p>
                          <p className="text-[#87889E] font-[700]">
                            {order?.delivery_customer_address}
                          </p>
                        </>
                      )}
                    </div>

                    <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center whitespace-nowrap">
                      {(order?.sub_total + order?.delivery_fee)}
                    </div>
                    <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center truncate">
                      {order?.delivery_method?.type_name}
                    </div>
                    <div className="hidden sm:block">
                      <h1 className="text-[14px] text-[#000] font-[500] text-center">
                        {formatDate(order?.created_at)}
                      </h1>
                      {/* <p className="text-[14px] text-[#87889E] font-[600] text-center">{item?.time}</p> */}
                    </div>
                    <div className="text-sm sm:text-[14px] flex flex-col gap-1">
                      <div className="text-base sm:text-[16px] text-red-600 font-[500] text-center">
                        {order?.sales_details.qty}
                      </div>
                      {isExpanded && (
                        <p className="text-xs sm:text-[14px] text-[#87889E] font-[700] break-words whitespace-normal leading-relaxed text-center">
                          {order.sales_details
                            .map((detail) => {
                              const productName =
                                detail.product_info?.name || "";
                              const variantName =
                                detail.product_variant?.name || "";
                              return variantName
                                ? `${productName} (${variantName})`
                                : productName;
                            })
                            .join(", ")}
                        </p>
                      )}
                    </div>
                    {
                      activeTab !== 'Order Received' && <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center truncate">
                        {order?.steadfast_courier?.consignment_id}
                      </div>
                    }
                    <div className="text-[12px] font-nunito font-[700] flex flex-col sm:flex-row gap-2 sm:justify-end sm:items-center w-full relative">
                      <button
                        onClick={() => { setShowDeliveryModal(true);  setOrderIndex(index)}}
                        className="block bg-[#407BFF] border border-[#407BFF] text-white hover:bg-[#2f5fd6] rounded-[5px] px-[8px] pt-[3px] pb-[1px] transition"
                      >
                        DELIVERY
                      </button>
                      {
                        <a
                          className="block w-full sm:w-auto text-center border-[1px] border-solid border-[#407BFF] text-[#407BFF] hover:text-[#407BFF] rounded-[5px] px-[5px] pt-[2px] pb-[0px]"
                          href={`/invoice/${order?.invoice_id}`}
                        >
                          VIEW
                        </a>
                      }
                      {
                        <a
                          className="block w-full sm:w-auto text-center rounded-[5px] text-[#FFF] hover:text-[#FFF] bg-[#407BFF] px-[12px] pt-[2px] pb-[2px]"
                          href={`/invoice/edit-ecommerce/${order?.invoice_id}`}
                        >
                          EDIT
                        </a>
                      }

                      {/* <a
                        onClick={() => showModalBeforeDelete(order?.id, index)}
                        className="cursor-pointer block w-full sm:w-auto text-center rounded-[5px] text-[#FFF] hover:text-[#FFF] bg-[#FF0303] px-[5px] pt-[2px] pb-[2px]"
                      >
                        DELETE
                      </a> */}

                      <div
                        onClick={() =>
                          setDropdownOpen(
                            dropdownOpen === order.id ? null : order.id
                          )
                        }
                        className="text-gray-400 hover:text-gray-500 ml-2 cursor-pointer self-end sm:self-auto shrink-0"
                      >
                        <MoreIcon />
                      </div>

                      {dropdownOpen === order.id && (
                        <div
                          ref={statusRef}
                          className={`absolute right-2 sm:right-0 mt-2 w-48 rounded-md shadow-lg  ring-1 ring-black ring-opacity-5 z-10 max-h-[50vh] overflow-y-auto`}
                        >
                          {order?.tran_status === 1 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 1)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 1
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Received
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 2)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 2
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Completed
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : order?.tran_status === 2 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 2)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 2
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Completed
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : order.tran_status === 3 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : invoices?.data && invoices?.data.length > 0 ? (
              invoices.data.map((order, index) => {
                const isExpanded = expandedRows[order.invoice_id] || false;
                return (
                  <div
                    key={index}
                    className={`py-1 sm:py-[13px] font-nunito grid ${activeTab !== 'Order Received' ? 'grid-cols-6 sm:grid-cols-7' : 'grid-cols-5 sm:grid-cols-6' } items-center gap-3 min-w-[900px] sm:min-w-0 px-4 sm:px-0 border-b border-[#E7EBF4]`}
                  >
                    <div className="text-sm sm:text-[14px] space-y-1 sm:space-y-0 min-w-0">
                      <h1 className="text-[#000232] font-[500] truncate max-w-[160px] sm:max-w-none">
                        {order?.invoice_id}
                      </h1>
                      <p className="text-[#87889E] font-[700]">
                        {order?.delivery_customer_name}
                      </p>
                      <button
                        onClick={() => toggleRow(order.invoice_id)}
                        className="text-[#000000] inline-flex items-center p-1 -ml-1"
                      >
                        {isExpanded ? (
                          <ChevronUp size={20} />
                        ) : (
                          <ChevronDown size={20} />
                        )}
                      </button>

                      {isExpanded && (
                        <>
                          <p className="text-[#87889E] font-[700]">
                            {order?.delivery_customer_phone}
                          </p>
                          <p className="text-[#87889E] font-[700]">
                            {order?.delivery_customer_address}
                          </p>
                        </>
                      )}
                    </div>

                    <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center whitespace-nowrap">
                      {order?.sub_total + order?.delivery_fee}
                    </div>
                    <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center truncate">
                      {order?.delivery_method?.type_name}
                    </div>
                    <div className="hidden sm:block">
                      <h1 className="text-[14px] text-[#000] font-[500] text-center">
                        {formatDate(order?.created_at)}
                      </h1>
                      {/* <p className="text-[14px] text-[#87889E] font-[600] text-center">{item?.time}</p> */}
                    </div>
                    <div className="text-sm sm:text-[14px] flex flex-col gap-1">
                      <div className="text-base sm:text-[16px] text-red-600 font-[500] text-center">
                        {order?.sales_details
                          ? order.sales_details.reduce(
                              (sum, item) => sum + (item.qty || 0),
                              0
                            )
                          : 0}
                      </div>
                      {isExpanded && (
                        <p className="text-xs sm:text-[14px] text-[#87889E] font-[700] break-words whitespace-normal leading-relaxed text-center">
                          {order.sales_details
                            .map((detail) => {
                              const productName =
                                detail.product_info?.name || "";
                              const variantName =
                                detail.product_variant?.name || "";
                              const quantity = detail.qty || 0;
                              return variantName
                                ? `${productName} ${variantName} (\u00D7${quantity})`
                                : productName;
                            })
                            .join(", ")}
                        </p>
                      )}
                    </div>

                    {
                      activeTab !== 'Order Received' && <div className="text-sm sm:text-[16px] text-[#000] font-[500] text-center truncate">
                        {order?.steadfast_courier?.consignment_id}
                      </div>
                    }

                    {/* <div className="text-[12px] font-nunito font-[700] flex flex-col sm:flex-row gap-2 sm:justify-end sm:items-center w-full relative">
                      <button
                        onClick={() => setShowDeliveryModal(true)}
                        className="block w-full sm:w-auto text-center bg-[#407BFF] border border-[#407BFF] text-white hover:bg-[#2f5fd6] rounded-[5px] px-[8px] pt-[3px] pb-[1px] transition"
                      >
                        DELIVERY
                      </button>

                      {
                        <a
                          className="block w-full sm:w-auto text-center border-[1px] border-solid border-[#407BFF] text-[#407BFF] hover:text-[#407BFF] rounded-[5px] px-[5px] pt-[2px] pb-[0px]"
                          href={`/invoice/${order?.invoice_id}`}
                        >
                          VIEW
                        </a>
                      }
                      {
                        <a
                          className="block w-full sm:w-auto text-center rounded-[5px] text-[#FFF] hover:text-[#FFF] bg-[#407BFF] px-[12px] pt-[2px] pb-[2px]"
                          href={`/invoice/edit-ecommerce/${order?.invoice_id}`}
                        >
                          EDIT
                        </a>
                      }

                      <a
                        onClick={() => showModalBeforeDelete(order?.id, index)}
                        className="cursor-pointer block w-full sm:w-auto text-center rounded-[5px] text-[#FFF] hover:text-[#FFF] bg-[#FF0303] px-[5px] pt-[2px] pb-[2px]"
                      >
                        DELETE
                      </a>

                      <div
                        onClick={() =>
                          setDropdownOpen((prev) =>
                            prev === order.id ? null : order.id
                          )
                        }
                        className="text-gray-400 hover:text-gray-500 ml-2 cursor-pointer self-end sm:self-auto shrink-0"
                      >
                        <MoreIcon />
                      </div>

                      {dropdownOpen === order.id && (
                        <div
                          ref={statusRef}
                          className={`absolute right-2 sm:right-0 mt-2 w-48 rounded-md shadow-lg  ring-1 ring-black ring-opacity-5 z-10 max-h-[50vh] overflow-y-auto`}
                        >
                          {order.tran_status === 1 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 1)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 1
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Received
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 2)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 2
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Completed
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 5)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700 text-left bg-white`}
                                role="menuitem"
                              >
                                Cancel
                              </button>
                            </div>
                          ) : order.tran_status === 2 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 2)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 2
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Order Completed
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : order.tran_status === 3 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 3)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 3
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivery processing
                              </button>
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : order.tran_status === 4 ? (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 4)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left ${
                                  order.tran_status === 4
                                    ? "bg-blue-500 text-white"
                                    : "bg-white text-gray-700"
                                } `}
                                role="menuitem"
                              >
                                Delivered
                              </button>
                            </div>
                          ) : (
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => handleOrderStatus(order, 1)}
                                className={`block w-full px-4 py-2 text-sm text-gray-700  text-left bg-white`}
                                role="menuitem"
                              >
                                Order Received
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div> */}
                    <div className="text-[12px] font-nunito font-[700] flex flex-col  gap-2 sm:justify-end sm:items-center w-full relative">
                      {/* <CHANGE> Added ORDER ACTIONS popup button */}
                      <div className="relative">
                        <button
                          onClick={() =>
                            setOrderActionsOpen((prev) =>
                              prev === order.id ? null : order.id
                            )
                          }
                          className="block w-full sm:w-auto text-center bg-[#407BFF] border border-[#407BFF] text-white hover:bg-[#2f5fd6] rounded-[5px] px-[8px] pt-[3px] pb-[1px] transition"
                        >
                          ORDER ACTIONS
                        </button>

                        {orderActionsOpen === order.id && (
                          <div
                            ref={actionsRef}
                            className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10"
                          >
                            <div className="py-1" role="menu">
                              <button
                                onClick={() => {
                                  setShowDeliveryModal(true);
                                  setOrderIndex(index)
                                  setOrderActionsOpen(null);
                                }}
                                className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                role="menuitem"
                              >
                                DELIVERY
                              </button>
                              <a
                                className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                href={`/invoice/${order?.invoice_id}`}
                                role="menuitem"
                                onClick={() => setOrderActionsOpen(null)}
                              >
                                VIEW
                              </a>
                              <a
                                className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                href={`/invoice/edit-ecommerce/${order?.invoice_id}`}
                                role="menuitem"
                                onClick={() => setOrderActionsOpen(null)}
                              >
                                EDIT
                              </a>15
                              {/* <button
                                onClick={() => {
                                  showModalBeforeDelete(order?.id, index);
                                  setOrderActionsOpen(null);
                                }}
                                className="block w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100 text-left"
                                role="menuitem"
                              >
                                DELETE
                              </button> */}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* <CHANGE> Added ORDER STATUS popup button */}
                      <div className="relative">
                        <button
                          onClick={() =>
                            setOrderStatusOpen((prev) =>
                              prev === order.id ? null : order.id
                            )
                          }
                          className="block w-full sm:w-auto text-center border-[1px] border-solid border-[#407BFF] text-[#407BFF] hover:bg-[#407BFF] hover:text-white rounded-[5px] px-[8px] pt-[3px] pb-[1px] transition"
                        >
                          ORDER STATUS
                        </button>

                        {orderStatusOpen === order.id && (
                          <div
                            ref={statusRef}
                            className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10 max-h-[50vh] overflow-y-auto"
                          >
                            {order.tran_status === 1 ? (
                              <div className="py-1" role="menu">
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 1);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 1
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Order Received
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 2);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 2
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Order Completed
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 3);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 3
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivery processing
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 4);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 4
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivered
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 5);
                                    setOrderStatusOpen(null);
                                  }}
                                  className="block w-full px-4 py-2 text-sm text-gray-700 text-left bg-white hover:bg-gray-100"
                                  role="menuitem"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 6);
                                    setOrderStatusOpen(null);
                                  }}
                                  className="block w-full px-4 py-2 text-sm text-gray-700 text-left bg-white hover:bg-gray-100"
                                  role="menuitem"
                                >
                                  Hold
                                </button>
                              </div>
                            ) : order.tran_status === 2 ? (
                              <div className="py-1" role="menu">
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 2);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 2
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Order Completed
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 3);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 3
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivery processing
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 4);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 4
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivered
                                </button>
                              </div>
                            ) : order.tran_status === 3 ? (
                              <div className="py-1" role="menu">
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 3);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 3
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivery processing
                                </button>
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 4);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 4
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivered
                                </button>
                              </div>
                            ) : order.tran_status === 4 ? (
                              <div className="py-1" role="menu">
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 4);
                                    setOrderStatusOpen(null);
                                  }}
                                  className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
                                    order.tran_status === 4
                                      ? "bg-blue-500 text-white"
                                      : "bg-white text-gray-700 hover:bg-gray-100"
                                  }`}
                                  role="menuitem"
                                >
                                  Delivered
                                </button>
                              </div>
                            ) : (
                              <div className="py-1" role="menu">
                                <button
                                  onClick={() => {
                                    handleOrderStatus(order, 1);
                                    setOrderStatusOpen(null);
                                  }}
                                  className="block w-full px-4 py-2 text-sm text-gray-700 text-left bg-white hover:bg-gray-100"
                                  role="menuitem"
                                >
                                  Order Received
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-base font-semibold my-5 text-center">
                No orders
              </p>
            )}
          </div>

          <div className="hrtable"></div>
          {/* Pagination component */}
          {shouldRenderPagination && (
            // {invoiceData.length > 2 && (
            <div className="px-4 sm:px-0">
              <Pagination
                lastPage={invoices?.last_page}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
          {/* Modal */}
          {showDeliveryModal && (
            <DeliveryModal
              onClose={() => {setShowDeliveryModal(false); setRefetch(!refetch);}}
              token={token}
              deliveryList={deliveryList}
              setRefetch={setRefetch}
              refetch={refetch}
              invoiceData={invoices?.data && invoices?.data.length > 0 ? invoices?.data[orderIndex] : searchedData[orderIndex]}
            />
          )}
        </div>

        {/* Pagination */}
        {/* <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500">Items per page</span>
      <select className="border rounded p-1 text-sm">
        <option>10</option>
        <option>20</option>
        <option>50</option>
      </select>
    </div>
    <div className="flex items-center gap-2">
      <button className="px-3 py-1 border rounded text-sm hover:bg-gray-50">Previous</button>
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, "...", 32].map((page, i) => (
          <button
            key={i}
            className={`px-3 py-1 rounded text-sm ${
              page === 1 ? "bg-blue-600 text-white" : "border hover:bg-gray-50"
            } ${typeof page === "string" ? "cursor-default hover:bg-transparent" : ""}`}
          >
            {page}
          </button>
        ))}
      </div>
      <button className="px-3 py-1 border rounded text-sm hover:bg-gray-50">Next</button>
    </div>
  </div> */}
      </div>
    </ContentLayout>
  );
};

export default Orders;
